(function () {
  // Move Wishlist by Square product-image overlay heart to the top-right corner.
  // The app (Vtl- prefix) injects inside .product-gallery__media with
  // inline style="top:0%;left:0%". CSS handles it declaratively; JS re-applies
  // on any mutation in case the app resets the inline style after our CSS loads.

  function applyRight(el) {
    // The wrapper may be full-width, making right:0.75rem ineffective.
    // Use left:calc(100% - offset) to land the icon at the right edge.
    // On mobile (<750px) the zoom button is at top-right so push heart below it.
    var isMobile = window.innerWidth < 750;
    el.style.setProperty('left', 'calc(100% - 2.5rem)', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('top', isMobile ? '3rem' : '0.75rem', 'important');
    el.style.setProperty('z-index', '5', 'important');
  }

  function scanGallery() {
    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    // Target only the outer wrapper (Vtl-WishlistIcon__ProductPageWrapper).
    // Targeting all [class*="Vtl-"] changed position on inner children too.
    var candidates = gallery.querySelectorAll('[class*="Vtl-WishlistIcon__ProductPageWrapper"]');
    for (var i = 0; i < candidates.length; i++) {
      applyRight(candidates[i]);
    }
  }

  // Client #11: move the Wishlist-by-Square button so it sits as a compact
  // heart to the RIGHT of the Add to Cart button, instead of a full-width
  // "Add to Wishlist" button beneath it. The Shop Pay button stays full-width
  // below. Idempotent — safe to call repeatedly from the MutationObserver.
  function relocateWishlistToATC() {
    var buyButtons = document.querySelector('buy-buttons');
    if (!buyButtons) return;

    var atc = buyButtons.querySelector('button.button, button[type="submit"]');
    var wishlist = document.querySelector('.product-info .Vtl-AppBlock, .product-info__block-item .Vtl-AppBlock');
    if (!atc || !wishlist) return;

    var row = buyButtons.querySelector('.td-atc-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'td-atc-row';
      atc.parentNode.insertBefore(row, atc);
      row.appendChild(atc);
    }

    if (wishlist.parentNode !== row) {
      var oldWrap = wishlist.closest('.product-info__block-item');
      row.appendChild(wishlist);
      if (oldWrap && oldWrap.children.length === 0) {
        oldWrap.style.display = 'none';
      }
    }
  }

  function scan() {
    scanGallery();
    relocateWishlistToATC();
  }

  function boot() {
    if (!document.querySelector('.product-gallery')) return;

    scan();

    var busy = false;
    new MutationObserver(function (muts) {
      if (busy) return;
      var relevant = muts.some(function (m) {
        return m.addedNodes.length > 0 || m.type === 'attributes';
      });
      if (!relevant) return;
      busy = true;
      scan();
      busy = false;
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
